require('./hireCardNerudaView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCardNerudaActions = require('actions/hireCardNeruda');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const shippingAddressAction = require('actions/shippingAddress');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardNerudaStep1 = require('components/hire/cardNeruda/hireCardNerudaStep1/hireCardNerudaStep1');
const HireCardNerudaStep2 = require('components/hire/cardNeruda/hireCardNerudaStep2/hireCardNerudaStep2');
const HireCardNerudaStep3 = require('components/hire/cardNeruda/hireCardNerudaStep3/hireCardNerudaStep3');
const HireCardNerudaStep4 = require('components/hire/cardNeruda/hireCardNerudaStep4/hireCardNerudaStep4');
const HireCardNerudaStep5 = require('components/hire/cardNeruda/hireCardNerudaStep5/hireCardNerudaStep5');
const HireCardNerudaSuccess = require('components/hire/cardNeruda/hireCardNerudaSuccess/hireCardNerudaSuccess');
const HireCarNerudaError = require('components/hire/cardNeruda/hireCardNerudaError/hireCardNerudaError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
  REDIRECT_URL,
  THIRD_STEP,
  WIZARD_FIRST_STEP,
  WIZARD_SECOND_STEP,
} = require('constants/index');
const { HIRE_CARD_OPEN_CREDIT } = require('constants/operationCodesAccounts');
const {
  CREDIT_CARD_REVOLVING_PROCESS,
  LIMIT_CREDIT_CARD,
  HORMIGUERO_CARD,
  NERUDA_CARD,
  VANITY_CARD,
  WEB_INACTIVE_ACCOUNT_ENABLED,
  ES_COUNTRY,
  MESSAGE_HIRE_24H,
  NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const {
  HORMIGUERO_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS_CC,
  VANITY_CARD_PRODUCT_ALIAS,
  VANITY_CARD_PRODUCT_ALIAS_CC
} = require('constants/hiringProductInformation');
const {
  catalogue,
  analyticsId,
} = require('components/hire/cardNeruda/analytics/hireCardNerudaViewAnalytics');

class HireCardNerudaView extends React.Component {
  constructor(props) {
    super(props);

    const { cardType, immFlagBasedFeatures, immProfile, history } = props;

    switch (cardType) {
      case 'neruda':
        if (!immFlagBasedFeatures.get(NERUDA_CARD)) {
          history.push('/myprofile/global');
        }
        break;
      case 'vanity':
        if (!immFlagBasedFeatures.get(VANITY_CARD)) {
          history.push('/myprofile/global');
        }

        // Validation by user with one neruda hired
        if (immProfile.get('isNerudaUser') && this.hasCardOfType('Neruda')) {
          history.push('/myprofile/hire/neruda-landing');
        }
        break;
      case 'hormiguero':
        if (!immFlagBasedFeatures.get(HORMIGUERO_CARD)) {
          history.push('/myprofile/global');
        }
        break;
      default:
        history.push('/myprofile/global');
    }

    let type = '';
    let subtype = '';
    let standard = '';
    switch (cardType) {
      case 'neruda':
        type = '500';
        subtype = '802';
        standard = '0000014';
        break;
      case 'vanity':
        type = '500';
        subtype = '805';
        standard = '0000001';
        break;
      case 'hormiguero':
        type = '500';
        subtype = '804';
        standard = '0000001';
        break;
    }

    props.setDataNerudaCard({
      standard,
      subtype,
      type,
    });

    this.getContextTranslate = this.getContextTranslate.bind(this);
    this.isReady = this.isReady.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    const {
      getBlockedAccounts,
      getshippingAddressList,
      immAccounts,
      match: {
        params: { redirect },
      },
      resetPrecontractualDocumentMail,
      validateStep
    } = this.props;
    resetPrecontractualDocumentMail();
    if (redirect === REDIRECT_URL) {
      validateStep(WIZARD_FIRST_STEP);
    }
    getshippingAddressList();
    getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_CREDIT);
  }

  componentWillUnmount() {
    const { reset, resetBlockedAccounts, resetPrecontractualMail, resetTermsAndCondsText } =
      this.props;

    reset();
    resetBlockedAccounts();
    resetTermsAndCondsText();
    if (__CONTACT_CENTER__) resetPrecontractualMail();
  }

  getProcessDetail() {
    const { immHireCardNeruda } = this.props;
    return `${immHireCardNeruda.get('type')}.${immHireCardNeruda.get('subtype')}`;
  }

  handleCancel() {
    this.props.history.push('/myprofile/cards');
  }

  buildINE() {
    const { immHireCardNeruda, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardNerudaPrintDocument } = this.props;
    const documentINE = immHireCardNeruda.get('documentINE')
    const scrollDown = immHireCardNeruda.get('scrollDown')
    const agreeIneCheckbox = immHireCardNeruda.get('agreeIneCheckbox')
    const checkButtonRadio = immHireCardNeruda.get('checkButtonRadio')
    const printDocument = immHireCardNeruda.get('printDocument')
    const documentsPrintedAndSigned = immHireCardNeruda.get('cardsDocumentsPrintedAndSigned')

    return (
      <HireCardOpenCreditStepINE
        documentINE={documentINE}
        cardsConfimationScrollDown={cardsConfimationScrollDown}
        scrollDown={scrollDown}
        checkCheckedDocument={checkCheckedDocument}
        agreeIneCheckbox={agreeIneCheckbox}
        printedAndSignedRadioChanged={printedAndSignedRadioChanged}
        enableButtonOffice={enableButtonOffice}
        checkRadioButton={checkRadioButton}
        checkButtonRadio={checkButtonRadio}
        hireCardOpenCreditprintDocument={hireCardNerudaPrintDocument}
        printDocument={printDocument}
        immPrinter={immPrinter}
        documentsPrintedAndSigned={documentsPrintedAndSigned}
      />
    );
  }

  isReady() {
    // it warns the user if he's about to lose changes
    const { immHireCardNeruda } = this.props;
    let showPreLeaveModal = true;

    if (immHireCardNeruda.get('visibleStep') === 1) {
      showPreLeaveModal = false;
    }

    return showPreLeaveModal;
  }

  getContextTranslate(translate) {
    const { cardType } = this.props;
    let contextCardType = '';
    switch (cardType) {
      case 'neruda':
        contextCardType = 'Neruda';
        break;
      case 'vanity':
        contextCardType = 'Vanity';
        break;
      case 'hormiguero':
        contextCardType = 'Hormiguero';
        break;
    }

    const context = `hireCard${contextCardType}-hireCard${contextCardType}_`;

    return `${context}${translate}`;
  }

  buildSuccessful() {
    const {
      immAccounts,
      immHireCardImageSelector,
      immHireCardNameSelector,
      immHireCardNeruda,
      immHireCreditLimit,
      immHirePaymentMethod,
      immProfile,
      immShippingAddressList,
    } = this.props;
    const selectedAccount = immHireCardNeruda.getIn(['steps', THIRD_STEP, 'accountId']);
    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
    const immShippingAddress = immShippingAddressList.get('shippingAddress');

    const processDetail = this.getProcessDetail();

    return (
      <div className="col-xs-12 col-md-offset-1 col-md-10">
        <HireCardNerudaSuccess
          getContextTranslate={this.getContextTranslate}
          immAccount={immAccount}
          immHireCardNeruda={immHireCardNeruda}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNameSelector={immHireCardNameSelector}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          immProfile={immProfile}
          immShippingAddress={immShippingAddress}
          processDetail={processDetail}
        />
      </div>
    );
  }

  getHireCmsKey() {
    let hireCmsKey;
    if (this.props.cardType === 'hormiguero') {
      hireCmsKey = HORMIGUERO_CARD_PRODUCT_ALIAS;
    } else if (this.props.cardType === 'vanity') {
      hireCmsKey = __CONTACT_CENTER__ ? VANITY_CARD_PRODUCT_ALIAS_CC : VANITY_CARD_PRODUCT_ALIAS;
    } else {
      hireCmsKey = __CONTACT_CENTER__ ? NERUDA_CARD_PRODUCT_ALIAS_CC : NERUDA_CARD_PRODUCT_ALIAS;
    }
    return hireCmsKey;
  }

  buildWizardHiringSteps() {
    const {
      cardType,
      handleAccountChange,
      handleAgreementCheckboxChange,
      hireCardNeruda,
      immAccounts,
      immFlagBasedFeatures,
      immGlobalVariables,
      immHireCardImageSelector,
      immHireCardNameSelector,
      immHireCardNeruda,
      immHireContactData,
      immHireCreditLimit,
      immHireInformation,
      immHirePaymentMethod,
      immProfile,
      immShippingAddressList,
      immPdfData,
      requestPDFDownload,
      requestPDFMerge,
      sendPrecontractualDocumentMail,
      setAllAccountsToInactive,
      setHireCreditLimit,
      setShippingAddress,
      setTermsAndCondsText,
      setVisibleStep,
      setWillCancel,
      toggleCreditLimitModal,
      validate,
      validateStep,
      immRevolvingPersistentData,
      onHandleChangeCheckBoxCC,
      myCardsTarjetasHire,
      hireCardOpenCreditprintDocument,
      cardsConfimationScrollDownPolicy,
      hireCardNerudaPrintDocumentPolicy,
      hireCardNerudaPrintDocument,
      printedAndSignedRadioChanged,
      enableButtonOffice,
      checkRadioButtonPolicy,
      getInitCardsDocuments,
      processEmail
    } = this.props;
    const hireCmsKey = this.getHireCmsKey();
    const showPreLeaveModal = this.isReady();
    const documentsPrintedAndSigned = immHireCardNeruda.get('cardsDocumentsPrintedAndSigned');
    const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

    const wizardActions = {
      cancel: this.handleCancel,
      finish: newCardsFF ? myCardsTarjetasHire : () => hireCardNeruda(hireCmsKey),
      setVisibleStep,
      setWillCancel,
      validateStep,
    };

    let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardNeruda.get('newSteps') : immHireCardNeruda.get('steps');
    const visibleStep = immHireCardNeruda.get('visibleStep')
    immSteps = immSteps.map((step, index) => {
      if (index < visibleStep) {
        return step.set('valid', true);
      }
      return step;
    });

    const sendMailParams = {
      type: immHireCardNeruda.get('type'),
      subType: immHireCardNeruda.get('subtype'),
      standar: immHireCardNeruda.get('standard'),
    };
    const immShippingAddress = immShippingAddressList.get('shippingAddress');
    const hasShippingAddress = true;
    const nextButtonDisabledStep2 =
      immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
    const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    const agreeIneCheckbox = immHireCardNeruda.get('agreeIneCheckbox')
    const checkButtonRadio = immHireCardNeruda.get('checkButtonRadio')

    const productName = this.getProcessDetail();
    const tealiumData = [
      catalogue[analyticsId.NERURA_CARD_STEP_1_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_2_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_3_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_4_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_5_VIEW]({ productName }),
    ];

    const isShippingAddressButtonDisabled =
      !!immShippingAddressList &&
      !immShippingAddressList.get('shippingAddressType') &&
      immFlagBasedFeatures.get(ES_COUNTRY);
    const loadingFlag = immHireCardNeruda.get('loadingFlag');
    const checkboxChecked = immHireCardNeruda.get('agreeIneCheckbox')
    const newFinalButtonDisabledCC = newCardsFF && checkboxChecked

    const commonSteps = [
      <WizardStep cancelButton={true} position="first" isLoading={loadingFlag}>
        <WebappRender>
          <HireCardNerudaStep1
            cardType={cardType}
            getContextTranslate={this.getContextTranslate}
            hireCmsKey={hireCmsKey}
            immFlagBasedFeatures={immFlagBasedFeatures}
            immHireCardNeruda={immHireCardNeruda}
            immHireInformation={immHireInformation}
            requestPDFMerge={requestPDFMerge}
            showIneAndRevolving={showIneAndRevolving}
          />
        </WebappRender>
        <ContactCenterRender>
          <HireCardNerudaStep1
            cardType={cardType}
            getContextTranslate={this.getContextTranslate}
            handleAgreementCheckboxChange={handleAgreementCheckboxChange}
            hireCmsKey={hireCmsKey}
            immFlagBasedFeatures={immFlagBasedFeatures}
            immHireCardNeruda={immHireCardNeruda}
            immHireInformation={immHireInformation}
            immProfileFields={immProfile}
            requestPDFMerge={requestPDFMerge}
            sendMailParams={sendMailParams}
            setTermsAndCondsText={setTermsAndCondsText}
            showIneAndRevolving={showIneAndRevolving}
          />
        </ContactCenterRender>
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        nextButtonDisabled={nextButtonDisabledStep2}
        onBackClick={false}
        position="middle"
      >
        <HireCardNerudaStep2
          cardType={cardType}
          getContextTranslate={this.getContextTranslate}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNameSelector={immHireCardNameSelector}
          immHireCardNeruda={immHireCardNeruda}
        />
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        nextButtonDisabled={
          immHireCreditLimit.get('isFetching') ||
          immRevolvingPersistentData.get('isIframeError')
        }
        onBackClick={false}
        position="middle"
      >
        <HireCardNerudaStep3
          getContextTranslate={this.getContextTranslate}
          handleAccountChange={handleAccountChange}
          immAccounts={immAccounts}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immGlobalVariables={immGlobalVariables}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNeruda={immHireCardNeruda}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
          setHireCreditLimit={setHireCreditLimit}
          toggleCreditLimitModal={toggleCreditLimitModal}
          validate={validate}
          setAllAccountsToInactive={setAllAccountsToInactive}
        />
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        onBackClick={false}
        position="middle"
        nextButtonDisabled={isShippingAddressButtonDisabled}
      >
        <HireCardNerudaStep4
          immHireContactData={immHireContactData}
          immShippingAddressList={immShippingAddressList}
          setShippingAddress={setShippingAddress}
          immFlagBasedFeatures={immFlagBasedFeatures}
          getInitCardsDocuments={getInitCardsDocuments}
          newCardsFF={newCardsFF}
        />
      </WizardStep>,
      <WizardStep
        addLoadingBehaviour
        cancelButton={true}
        immFinalButton={this.getContextTranslate('hire')}
        isLoading={immHireCardNeruda.get('isFetching')}
        onBackClick={false}
        position="last"
        officeSignature={newCardsFF && isPrintOfficeMode()}
        finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
      >
        <HireCardNerudaStep5
          cardType={cardType}
          getContextTranslate={this.getContextTranslate}
          contractName="visa-open"
          handleAgreementCheckboxChange={handleAgreementCheckboxChange}
          immHireCardNameSelector={immHireCardNameSelector}
          immHireCardNeruda={immHireCardNeruda}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immPdfData={immPdfData}
          immProfile={immShippingAddressList.get('shippingAddress')}
          immShippingAddressList={immShippingAddressList}
          operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_visaOpenNew" : undefined}
          requestPDFDownload={requestPDFDownload}
          sendMailParams={sendMailParams}
          sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
          setTermsAndCondsText={setTermsAndCondsText}
          showIneAndRevolving={showIneAndRevolving}
          onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
          hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
          cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
          hireCardNerudaPrintDocumentPolicy={hireCardNerudaPrintDocumentPolicy}
          hireCardNerudaPrintDocument={hireCardNerudaPrintDocument}
          printedAndSignedRadioChanged={printedAndSignedRadioChanged}
          enableButtonOffice={enableButtonOffice}
          checkRadioButtonPolicy={checkRadioButtonPolicy}
          documentsPrintedAndSigned={documentsPrintedAndSigned}
          processEmail={processEmail}

        />
      </WizardStep>
    ];

    const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
      ...commonSteps.slice(0, 4),
      <WizardStep
        cancelButton={true}
        onBackClick={false}
        position="middle"
        nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
        immFlagBasedFeatures={immFlagBasedFeatures}
      >
        {this.buildINE()}
      </WizardStep>,
      ...commonSteps.slice(4)
    ] : commonSteps;

    return (
      <div>
        <div className="col-xs-12 col-md-8">
          <Wizard
            actions={wizardActions}
            immSteps={immSteps}
            showPreLeaveModal={showPreLeaveModal}
            stepsAmount={immSteps.size}
            wizardClass="hire-card-neruda__wizard"
            tealium={tealiumData[visibleStep - 1]}
            visibleStep={visibleStep}

            isTaggingSecondVersion
          >
            {newSteps}
          </Wizard>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="row">
            <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
              <HireCardSidebar
                hasShippingAddress={hasShippingAddress}
                immAccounts={immAccounts}
                immAddress={immShippingAddress}
                immGlobalVariables={immGlobalVariables}
                immHireCardImageSelector={immHireCardImageSelector}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCreditLimit={immHireCreditLimit}
                immHirePaymentMethod={immHirePaymentMethod}
                immShippingAddressList={immShippingAddressList}
                immProfile={immProfile}
                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
              />
            </div>
            <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
              <CallMeBack
                hasEntrance={false}
                context="contracts"
                modifier="contracts-view"
                pageTitle={formatText('breadcrumb-cards')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  hasCardOfType(type) {
    const { immCards } = this.props;
    const typeOfCard = `is${type}Card`;

    const hasCardOfType = immCards.getIn(['credit', 'byOrder']).some(cardId => {
      const immCard = immCards.getIn(['byId', cardId]);
      return immCard.get(typeOfCard) && immCard.get('status') === 'EN VIGOR';
    });

    return hasCardOfType;
  }

  render() {
    const { immAccounts, immCards, immFlagBasedFeatures, immHireCardNeruda, immProfile } =
      this.props;
    const pageTitle = getFinalTitle(this.getContextTranslate('pageTitle'));
    const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
    const isSecondStep = immHireCardNeruda.get('visibleStep') == WIZARD_SECOND_STEP;
    const isNerudaUser = immProfile.get('isNerudaUser');
    const creditCardsLimitExceed =
      immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) &&
      !isNerudaUser &&
      !hasAvailableCreditCards &&
      isSecondStep;
    let hasAvailableAccounts = true;
    if (__CONTACT_CENTER__) {
      hasAvailableAccounts = ownerFromAccount(immAccounts);
    }

    const mappingBreadcrumb = [
      {
        text: formatText('breadcrumb-cards'),
        url: '/myprofile/cards',
      },
      {
        text: formatText(this.getContextTranslate('breadcrumb')),
      },
    ];

    const processDetail = this.getProcessDetail();
    const hireRestrictionFlag = immHireCardNeruda.getIn([
      'steps',
      WIZARD_FIRST_STEP - 1,
      'hireRestriction',
    ]);
    const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

    let content;

    if (
      immHireCardNeruda.get('error') ||
      (__CONTACT_CENTER__ && !hasAvailableAccounts) ||
      creditCardsLimitExceed
    ) {
      content = (
        <div className="col-xs-12 col-md-offset-1 col-md-10">
          <HireCarNerudaError
            getContextTranslate={this.getContextTranslate}
            immHireCardNeruda={immHireCardNeruda}
            hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
            maxAllowedNumberCards={creditCardsLimitExceed}
            processDetail={processDetail}
          />
        </div>
      );
    } else if (hireRestrictionFlag && hireRestrictionFF) {
      content = (
        <div className="col-xs-12 col-md-offset-1 col-md-10">
          <HireCarNerudaError
            getContextTranslate={this.getContextTranslate}
            immHireCardNeruda={immHireCardNeruda}
            hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
            maxAllowedNumberCards={creditCardsLimitExceed}
            processDetail={processDetail}
            hireRestrictionFlag={hireRestrictionFlag}
          />
        </div>
      );
    } else if (immHireCardNeruda.get('submitSuccessful')) {
      content = this.buildSuccessful();
    } else if (immHireCardNeruda.get('type') !== 0) {
      content = this.buildWizardHiringSteps();
    }

    return (
      <div className="hire-card-neruda">
        <div className="container-fluid">
          <div className="row">
            <OKCover size="medium" section="pg" customClass="col-xs-12">
              <OKHeaderSubPage breadcrumbConfig={mappingBreadcrumb} finalTitle={pageTitle} />
            </OKCover>
          </div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
            <div className="row grid-view--content-position-negative">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

HireCardNerudaView.propTypes = {
  cardType: PropTypes.oneOf(['neruda', 'vanity', 'hormiguero']),
  getBlockedAccounts: PropTypes.func,
  getshippingAddressList: PropTypes.func,
  handleAccountChange: PropTypes.func.isRequired,
  handleAgreementCheckboxChange: PropTypes.func.isRequired,
  hireCardNeruda: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  immAccounts: PropTypes.object.isRequired,
  immCards: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object.isRequired,
  immGlobalVariables: PropTypes.object.isRequired,
  immHireCardImageSelector: PropTypes.object.isRequired,
  immHireCardNameSelector: PropTypes.object.isRequired,
  immHireCardNeruda: PropTypes.object.isRequired,
  immHireContactData: PropTypes.object.isRequired,
  immHireCreditLimit: PropTypes.object.isRequired,
  immHireInformation: PropTypes.object.isRequired,
  immHirePaymentMethod: PropTypes.object.isRequired,
  immProfile: PropTypes.object.isRequired,
  immPdfData: PropTypes.object.isRequired,
  immShippingAddressList: PropTypes.object,
  isNeruda: PropTypes.bool,
  location: PropTypes.object.isRequired,
  match: PropTypes.object,
  reset: PropTypes.func.isRequired,
  resetPrecontractualMail: PropTypes.func.isRequired,
  resetTermsAndCondsText: PropTypes.func.isRequired,
  requestPDFMerge: PropTypes.func.isRequired,
  requestPDFDownload: PropTypes.func.isRequired,
  resetBlockedAccounts: PropTypes.func,
  resetPrecontractualDocumentMail: PropTypes.func,
  sendPrecontractualDocumentMail: PropTypes.func.isRequired,
  setAllAccountsToInactive: PropTypes.func.isRequired,
  setDataNerudaCard: PropTypes.func.isRequired,
  setHireCreditLimit: PropTypes.func.isRequired,
  setShippingAddress: PropTypes.func,
  setTermsAndCondsText: PropTypes.func.isRequired,
  setVisibleStep: PropTypes.func.isRequired,
  setWillCancel: PropTypes.func.isRequired,
  toggleCreditLimitModal: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  validateStep: PropTypes.func.isRequired,
  immRevolvingPersistentData: PropTypes.func.object,
};

module.exports.constructor = HireCardNerudaView;
module.exports.HireCardNerudaView = connect(
  state => ({
    immAccounts: state.accounts,
    immCards: state.cards,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immGlobalVariables: state.globalVariables,
    immHireCardImageSelector: state.hireCardImageSelector,
    immHireCardNameSelector: state.hireCardNameSelector,
    immHireCardNeruda: state.hireCardNeruda,
    immHireContactData: state.hireContactData,
    immHireCreditLimit: state.hireCreditLimit,
    immHireInformation: state.hireInformation,
    immHirePaymentMethod: state.hirePaymentMethod,
    immPdfData: state.precontractualsMergePdfs,
    immProfile: state.profile,
    immShippingAddressList: state.shippingAddress,
    immRevolvingPersistentData: state.revolvingPersistentData,
    immPrinter: state.printer,
  }),
  {
    getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
    getshippingAddressList: shippingAddressAction.getShippingAddressList,
    handleAccountChange: hireCardNerudaActions.setAccount,
    handleAgreementCheckboxChange: hireCardNerudaActions.setAgreementCheckbox,
    onHandleChangeCheckBoxCC: hireCardNerudaActions.onHandleChangeCheckBoxCC,
    hireCardNeruda: hireCardNerudaActions.hireCardNeruda,
    requestPDFDownload: mergePreContractualsPDF.downloadMergedPDF,
    requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
    reset: hireCardNerudaActions.reset,
    resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
    resetPrecontractualDocumentMail:
      precontractualDocumentMailAction.resetPrecontractualDocumentMail,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetTermsAndCondsText: termsAndCondsInfoActions.reset,
    sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
    setAllAccountsToInactive: hireCardNerudaActions.setAllAccountsToInactive,
    setDataNerudaCard: hireCardNerudaActions.setDataNerudaCard,
    setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
    setShippingAddress: shippingAddressAction.setShippingAddress,
    setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
    setVisibleStep: hireCardNerudaActions.setVisibleStep,
    setWillCancel: hireCardNerudaActions.setWillCancel,
    toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
    validate: hireCardNerudaActions.validate,
    validateStep: hireCardNerudaActions.validateStep,
    cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
    cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
    checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
    printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
    enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
    checkRadioButton: hireCardNerudaActions.checkRadioButton,
    checkRadioButtonPolicy: hireCardNerudaActions.checkRadioButtonPolicy,
    hireCardNerudaPrintDocument: hireCardNerudaActions.printDocument,
    hireCardNerudaPrintDocumentPolicy: hireCardNerudaActions.printDocumentPolicy,
    myCardsTarjetasHire: hireCardNerudaActions.myCardsTarjetasHire,
    getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
    processEmail: hireCardNerudaActions.processEmail,

  }
)(withRouter(HireCardNerudaView));
